import { useEffect } from "react";
import {
  isTrackedJobId,
  trackMetaJobPageView,
} from "utils/metaPixelJob";

/**
 * Loads the Meta Pixel only on job detail routes (optionally filtered by env) and sends PageView with content_ids.
 */
export function useMetaPixelForTrackedJobPage(routeJobId: string | undefined): void {
  useEffect(() => {
    if (!routeJobId || !isTrackedJobId(routeJobId)) {
      return;
    }
    trackMetaJobPageView(routeJobId);
  }, [routeJobId]);
}
